'use es6';

import { combineReducers } from 'redux';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import Immutable from 'immutable';
import * as ActionTypes from '../actions/ActionTypes';
import { PAGE_KEY, REVIEWS_PER_PAGE } from 'ecosystem-marketplace-core/constants/reviews/ReviewsListQueries';
import * as ReviewTypes from 'ecosystem-marketplace-core/constants/reviews/ReviewType';
import Review from 'ecosystem-marketplace-core/records/Review';
import ReviewStats from 'ecosystem-marketplace-core/records/ReviewStats';
import ReviewFilters from 'ecosystem-marketplace-core/records/ReviewFilters';
import Reviewability from '../records/ThemeReviewability';
const EMPTY_LIST = Immutable.List();

const listRequestState = (state = RequestStates.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.REVIEWS_LIST_REQUESTED:
      return RequestStates.PENDING;

    case ActionTypes.REVIEWS_LIST_RECEIVED:
      return RequestStates.SUCCEEDED;

    case ActionTypes.REVIEWS_LIST_FAILED:
      return RequestStates.FAILED;

    case ActionTypes.REVIEWS_LIST_RESET:
      return RequestStates.UNINITIALIZED;

    default:
      return state;
  }
};

const list = (state = EMPTY_LIST, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWS_LIST_RECEIVED:
      return new Immutable.List(Review.fromArray(payload.reviews));

    case ActionTypes.REVIEW_HELPFUL_RECEIVED:
      {
        const indexToUpdate = state.findIndex(review => review.get('id') === payload.reviewId);
        return state.update(indexToUpdate, review => review.toggleHelpful(payload.reviewId, payload.userId, payload.isHelpful));
      }

    case ActionTypes.REVIEW_WRITE_RECEIVED:
      {
        return state.size === REVIEWS_PER_PAGE ? state.pop().unshift(Review.from(payload)) : state.unshift(Review.from(payload));
      }

    case ActionTypes.REVIEWS_LIST_RESET:
      {
        return EMPTY_LIST;
      }

    default:
      return state;
  }
};

const total = (state = 0, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWS_LIST_RECEIVED:
      return payload.total;

    case ActionTypes.REVIEW_WRITE_RECEIVED:
      return state + 1;

    default:
      return state;
  }
};

const statsRequestState = (state = RequestStates.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.REVIEW_STATS_REQUESTED:
      return RequestStates.PENDING;

    case ActionTypes.REVIEW_STATS_RECEIVED:
      return RequestStates.SUCCEEDED;

    case ActionTypes.REVIEW_STATS_FAILED:
      return RequestStates.FAILED;

    case ActionTypes.REVIEW_STATS_RESET:
    case ActionTypes.REVIEW_WRITE_RECEIVED:
      return RequestStates.UNINITIALIZED;

    default:
      return state;
  }
};

const stats = (state = new ReviewStats(), {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEW_STATS_RECEIVED:
      return ReviewStats.from(payload).set('reviewType', ReviewTypes.THEME);

    case ActionTypes.REVIEW_STATS_RESET:
      {
        return new ReviewStats();
      }

    default:
      return state;
  }
};

const filters = (state = new ReviewFilters(), {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEW_FILTERS_INITIALIZED:
      return ReviewFilters.from({
        reviewType: ReviewTypes.THEME,
        offeringId: payload.offeringId
      });

    case ActionTypes.REVIEW_FILTERS_UPDATED:
      {
        const page = PAGE_KEY.toLowerCase();
        let newFilters = state.merge(payload.updates);

        if (!payload.updates.page) {
          newFilters = newFilters.merge({
            [page]: 1
          });
        }

        return newFilters;
      }

    default:
      return state;
  }
};

const reviewabilityRequestState = (state = RequestStates.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.REVIEWABILITY_REQUESTED:
      return RequestStates.PENDING;

    case ActionTypes.REVIEWABILITY_RECEIVED:
      return RequestStates.SUCCEEDED;

    case ActionTypes.REVIEWABILITY_FAILED:
      return RequestStates.FAILED;

    case ActionTypes.REVIEW_WRITE_RECEIVED:
    case ActionTypes.REVIEWABILITY_RESET:
      return RequestStates.UNINITIALIZED;

    default:
      return state;
  }
};

const reviewability = (state = new Reviewability(), {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWABILITY_RECEIVED:
      return new Reviewability(payload);

    default:
      return state;
  }
};

export default combineReducers({
  listRequestState,
  list,
  total,
  statsRequestState,
  stats,
  filters,
  reviewabilityRequestState,
  reviewability
});